/* eslint-disable max-len */
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
const SvgErrorIcon = (props: SvgProps) => (
  <Svg
    // @ts-ignore
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <Path
      fill="#F4256A"
      d="M44.4 35.267 28.003 6.79a4.643 4.643 0 0 0-8.006 0L3.6 35.267a4.41 4.41 0 0 0 0 4.447A4.57 4.57 0 0 0 7.603 42h32.794a4.57 4.57 0 0 0 4-2.286 4.41 4.41 0 0 0 .003-4.447m-2.6 2.945a1.6 1.6 0 0 1-1.403.788H7.603a1.6 1.6 0 0 1-1.402-.788 1.42 1.42 0 0 1 0-1.447L22.598 8.289a1.64 1.64 0 0 1 2.812 0l16.397 28.476a1.42 1.42 0 0 1-.008 1.447M22.5 27v-7.5a1.5 1.5 0 1 1 3 0V27a1.5 1.5 0 1 1-3 0m3.75 6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
    />
  </Svg>
);
export default SvgErrorIcon;
